import type { ModuleConfiguration } from '@interhyp/platform-module';

import type { ModuleName } from '../types/ModuleName.js';
import { inspectModule } from '../utils.js';
import { withSpan } from '../utils/withSpan.js';
import { MFError, prefix } from '../errors/MFError.js';

import { getModuleImport } from './getModuleImport.js';

export const getModuleExtensions = async (moduleId: ModuleName) => {
  const module = await withSpan<ModuleConfiguration>(prefix(`Fetching ${inspectModule(moduleId)}`), () => getModuleImport(moduleId));

  if (!module) {
    throw new MFError(`Module not found`, moduleId);
  }

  const extensions = [...(module.plugins ?? []), ...(module.extensions ?? [])];

  if (!extensions || extensions.length === 0) {
    throw new MFError(`Extensions missing`);
  }

  return extensions;
};
